/** 与 Card 标题条视觉一致，供 details 等折叠块复用 */
export const detailsShellClass =
  'mb-6 overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-sm shadow-slate-900/[0.04]';

export const detailsSummaryClass =
  'flex cursor-pointer list-none items-center justify-between gap-2 border-b border-slate-100 bg-gradient-to-r from-indigo-50/40 to-slate-50/80 px-5 py-3 [&::-webkit-details-marker]:hidden';

export const detailsTitleClass = 'border-l-[3px] border-indigo-500 pl-3 text-sm font-semibold text-slate-800';
